import { render, staticRenderFns } from "./ProjectEditTabInformation.vue?vue&type=template&id=5b7cdcb2&"
import script from "./ProjectEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./ProjectEditTabInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports